import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';

/**
 * Shared disabled rule for every add-to-basket CTA (main button, round icon):
 * a size cannot be added when it is sold out or the basket already holds all
 * available stock.
 */
export const isAddToBasketDisabledForSize = (
  size: SizeSelection_Size | undefined,
  quantityInBasket: number,
): boolean =>
  size?.availability?.$case === 'soldOut' ||
  (size?.availability?.$case === 'inStock' &&
    size.availability.inStock.quantity <= quantityInBasket);
